<!-- 테이블 뷰 컴포넌트 -->
<template>
    <div class="table-view">
        <div v-if="filterSystemType.sumAvail == 'N'">
            <!-- 설비노드인 경우 -->
            <div
                class="col d-flex flex-wrap justify-content-start align-items-start"
                style="height: 100%; gap: 10px"
            >
                <div v-for="(item, index) in summary" :key="index" class="gauge-container">
                    <SummaryGaugeChart :data="item" />
                </div>
            </div>

            <TableListComponent
                ref="TableListComponent"
                :title="''"
                :columns="columns"
                :rows="rows"
                :useFilter="false"
                :keyField="
                    filterSystemType.sumAvail == 'N' &&
                    (currentNode.nodeType == 'Root' || currentNode.nodeType == 'System')
                        ? 'equipIdx'
                        : 'equipName'
                "
                :transCodes="
                    filterSystemType.sumAvail == 'Y' ||
                    currentNode.nodeType !== 'Group' ||
                    currentNode.nodeType !== 'Equip'
                        ? transCodes
                        : []
                "
                :iconClass="'fas fa-share'"
                :mode="'edit'"
                :iconField="'ctrl'"
                :customMaxHeight="'65vh'"
                :customRowHeight="'55%'"
                :fixedHeader="false"
                :propertyField="'property'"
                @buttonClick="$emit('button-click', $event)"
            />
        </div>
        <div v-else class="row m-0">
            <!-- 에너지 부하노드인 경우 -->
            <div class="row mr-0 ml-0 d-flex" style="height: 300px; width: 100%; margin-bottom: 2rem">
                <!-- 1단: 현재 부하 노드의 전체 현황 표시 -->
                <div class="col-3 pl-0 pl-0" style="height: 100%">
                    <GaugeChart v-if="!isEmpty(engGaugeData)" :data="engGaugeData" />
                </div>
                <div class="col-5 pl-0 pl-0" style="height: 100%">
                    <DoughnutChart v-if="!isEmpty(engDoughnutData)" :data="engDoughnutData" />
                </div>
                <div
                    class="col-4 flex-grow-1"
                    style="
                        padding: 0.5rem;
                        text-align: center;
                        border: 1px solid #ececec;
                        border-radius: 10px;
                        box-shadow: 3px 3px 3px #ececec;
                    "
                >
                    <TableListComponent
                        v-if="rows"
                        ref="TableListComponent"
                        :columns="columns"
                        :rows="rows"
                        :useFilter="
                            filterSystemType.sumAvail == 'N' &&
                            (currentNode.nodeType == 'Root' || currentNode.nodeType == 'System')
                        "
                        :keyField="
                            filterSystemType.sumAvail == 'N' &&
                            (currentNode.nodeType == 'Root' || currentNode.nodeType == 'System')
                                ? 'equipIdx'
                                : 'equipName'
                        "
                        :transCodes="
                            filterSystemType.sumAvail == 'Y' ||
                            currentNode.nodeType !== 'Group' ||
                            currentNode.nodeType !== 'Equip'
                                ? transCodes
                                : []
                        "
                        :groupField="
                            filterSystemType.sumAvail == 'N' &&
                            (currentNode.nodeType == 'Root' || currentNode.nodeType == 'System')
                                ? 'groupKey'
                                : ''
                        "
                        :iconClass="'fas fa-share'"
                        :mode="'view'"
                        :iconField="'ctrl'"
                        :customMaxHeight="'250px'"
                        :customRowHeight="'100%'"
                        :fixedHeader="false"
                        :propertyField="'property'"
                        @buttonClick="$emit('button-click', $event)"
                    />
                </div>
            </div>
            <!-- 2단: 하위 구성요소의 대표값 표시 -->
            <div class="gauge-wrap">
                <div v-for="(item, index) in engGaugeDatas" :key="index" class="gauge-container">
                    <SummaryGaugeChart :data="item" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TableListComponent from "@src/views/component/v2.1/ListDetailView/TableList.vue";
import SummaryGaugeChart from "../../charts/SummaryGaugeChart.vue";
import GaugeChart from "../../charts/GaugeChart.vue";
import DoughnutChart from "../../charts/DoughnutChart.vue";

export default {
    name: "TableView",
    components: {
        TableListComponent,
        SummaryGaugeChart,
        GaugeChart,
        DoughnutChart,
    },
    props: {
        filterSystemType: {
            type: Object,
            required: true,
        },
        currentNode: {
            type: Object,
            required: true,
        },
        summary: {
            type: Array,
            default: () => [],
        },
        columns: {
            type: Array,
            default: () => [],
        },
        rows: {
            type: Array,
            default: () => [],
        },
        transCodes: {
            type: Array,
            default: () => [],
        },
        engGaugeData: {
            type: Object,
            default: null,
        },
        engDoughnutData: {
            type: Array,
            default: () => [],
        },
        engGaugeDatas: {
            type: Array,
            default: () => [],
        },
    },
    emits: ["button-click"],
    methods: {
        // TableListComponent 참조 접근 메서드
        getTableListComponent() {
            return this.$refs.TableListComponent;
        },
        // 선택된 속성 가져오기 (설비 제어용)
        getSelectProperty() {
            if (this.$refs.TableListComponent) {
                return this.$refs.TableListComponent.getSelectProperty();
            }
            return [];
        },
        // 체크된 행 가져오기
        getCheckedRows() {
            if (this.$refs.TableListComponent) {
                return this.$refs.TableListComponent.getCheckedRows();
            }
            return [];
        },
    },
};
</script>

<style lang="scss" scoped>
.gauge-wrap {
    height: 450px;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    gap: 5px 18px;
    display: flex;
    flex-wrap: wrap;
    border: 1px solid #ececec;
    border-radius: 10px;
    box-shadow: 2px 2px 2px #ececec;
}

.gauge-container {
    width: 220px;
    height: 200px;
    margin: 10px;
    flex: 1 1 1;
}
</style>
